import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'sk',
    fullName: 'Slovak',
    nativeName: 'Slovenčina',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Niečo úžasné sa blíži",
    landing_subtitle: "ArgVoid je štúdio na vývoj aplikácií a hier. Zostaňte naladení, čoskoro prídu nové veci!",
    select_language: "Vyberte Jazyk",
    search_placeholder: "Hľadať jazyky...",
    terms_title: "Zmluvné podmienky",
    policy_title: "Zásady ochrany osobných údajov",
    cookies_title: "Zásady používania súborov cookie",
    terms_content: `
        <strong>1. Prijatie Podmienok</strong><br>
        Prístupom k ArgVoid sú akceptované tieto Zmluvné podmienky. Ak s týmito podmienkami nesúhlasíte, služba by sa nemala používať.<br><br>

        <strong>2. Využitie platformy</strong>X<br>
        ArgVoid a jeho aplikácie sú poskytované „tak ako sú“ na informačné a kreatívne účely. Služba sa musí používať iba na zákonné účely.<br><br>

        <strong>3. Zakázané správanie</strong><br>
        Zneužívanie slabých miest stránok, spamovanie alebo pokusy o neoprávnený prístup k infraštruktúre sú prísne zakázané.<br><br>

        <strong>4. Zrieknutie sa zodpovednosti</strong><br>
        Platforma a služby môžu byť kedykoľvek upravené bez upozornenia. Neposkytuje sa žiadna záruka týkajúca sa dostupnosti alebo dostupnosti služby.
    `,
    policy_content: `
        <strong>1. Zbierka informácií</strong><br>
        Platforma v súčasnosti nevyžaduje overenie používateľa ani vytvorenie účtu. Od návštevníkov sa aktívne nezhromažďujú žiadne osobné identifikačné informácie (ako sú mená alebo e-mailové adresy).<br><br>

        <strong>2. Údaje o použití</strong>X<br>
        Základné, anonymizované analýzy môžu byť zhromažďované s cieľom pochopiť návštevnosť stránok a zlepšiť aplikácie. Tieto údaje nie sú prepojené s jednotlivými identitami používateľov.<br>X<br>

        <strong>3. Služby tretích strán</strong><br>
        Na hostingové a analytické služby môžu byť využívaní poskytovatelia tretích strán. Postupy ochrany osobných údajov týchto príslušných poskytovateľov riadia anonymné údaje spracúvané v ich infraštruktúre.<br><br>

        <strong>4. Zabezpečenie údajov</strong><br>
        Na ochranu platformy sú implementované primerané bezpečnostné opatrenia. Žiadny spôsob prenosu cez internet však nie je úplne bezpečný.<br><br>
    `,
    cookies_content: `
        <strong>1. Čo sú súbory cookie a miestne úložisko?</strong><br>
        Súbory cookie a miestne úložisko prehliadača sú malé dátové súbory uložené v zariadení na zapamätanie si konfiguračných preferencií počas návštev.<br><br>

        <strong>2. Účel použitia</strong><br>
        Prehliadač LocalStorage sa používa výhradne na uloženie konfiguračných nastavení, ako napríklad: <br>
        - Jazykové preferencie<br>
        - Konfigurácia používateľského rozhrania (napr. nastavenia rozloženia alebo témy) <br>
        - Dočasná vyrovnávacia pamäť aplikácie<br><br>

        <strong>3. Žiadne sledovanie</strong><br>
        Súbory cookie a miestne úložisko sa nepoužívajú na reklamné účely ani na účely sledovania tretích strán. Všetky uložené údaje slúžia výlučne na základnú funkčnosť platformy.<br><br>

        <strong>4. Control</strong><br>
        Údaje prehliadača je možné kedykoľvek vymazať prostredníctvom nastavení prehliadača, čím sa obnovia všetky miestne konfigurácie.
    `,
    cookie_consent_text: "Základné súbory cookie používame na zabezpečenie správneho fungovania webovej stránky, ako je napríklad udržiavanie aktívnej relácie, ukladanie predvolieb jazyka a iné vlastné konfigurácie.",
    read_policy: "Prečítajte si Zásady používania súborov cookie",
    support_title: "Kontaktujte podporu",
    support_subject_label: "Predmet",
    support_message_label: "Správa",
    support_submit_button: "Odoslať správu",
    support_hint: "Poznámka: Týmto sa otvorí vaša predvolená e-mailová aplikácia na odoslanie správy.",
    support_success_msg: "Otvára sa vaša e-mailová aplikácia...",
    support_error_msg: "Odoslanie správy zlyhalo. Skúste to znova neskôr.",
    explorer_title: "Prieskumník",
    history_title: "História",
    animation_title: "Animácia",
    config_title: "Konfigurácia",
    tool_mouse: "Vybrať (Ctrl+M)",
    tool_brush: "Štetec (Ctrl+B)",
    tool_brush_mode: "Prepnúť režim (plné/jasné)",
    tool_eraser: "Guma (Ctrl+E)",
    tool_brush_size: "Upravte veľkosť štetca",
    tool_bucket: "Vyplniť (Ctrl+F)",
    tool_eyedropper: "Kvapkadlo",
    tool_grid: "Mriežka (Ctrl+Shift+B)",
    tool_rotate: "Otočiť (Ctrl+Shift+R)",
    tool_flip_h: "Otočiť H (Ctrl+Shift+H)",
    tool_flip_v: "Otočiť V (Ctrl+Shift+V)",
    tool_transpose: "Transponovať (Ctrl+Shift+T)",
    label_width: "šírka",
    label_height: "Výška",
    label_frames: "Počet snímok",
    label_animation: "Štýl animácie",
    label_background_color: "Farba pozadia",
    label_interval: "Interval",
    tool_anim_config: "Konfigurácia animácie",
    label_new_width: "Nová šírka",
    label_new_height: "Nová výška",
    label_apply: "Použiť",
    label_colors: "Farby",
    label_size: "Veľkosť",
    label_tolerance: "Tolerancia",
    val_horizontal: "Horizontálne",
    val_vertical: "Vertikálne",
    val_sequence: "Sekvencia",
    val_bounce: "Odraziť",
    val_random: "Náhodný",
    val_solid: "Pevné",
    val_clear: "Jasné",
    action_add_sheet: "Nový list",
    action_import: "Importovať",
    action_export: "Exportovať",
    action_sort_projects: "Triediť",
    sort_date_old: "Najstaršia prvá",
    sort_date_new: "Najnovšie prvé",
    sort_name_az: "Meno (A-Z)",
    sort_name_za: "Meno (Z-A)",
    action_new_sprite: "Nový Sprite",
    action_new_project: "Nový projekt",
    modal_save_all_title: "Uložiť všetky zmeny",
    modal_save_all_desc: "Vyberte aktíva, ktoré chcete uložiť:",
    modal_save_selected: "Uložiť vybraté",
    action_saved: "Uložené",
    modal_create_sprite_title: "Vytvorte nového Sprite",
    modal_create_project_title: "Vytvoriť nový projekt",
    modal_add_sheet_title: "Pridať nový hárok",
    modal_rename_sheet_title: "Premenovať hárok",
    modal_rename_sprite_title: "Premenovať Sprite",
    modal_delete_sprite_title: "Odstrániť Sprite",
    modal_delete_project_title: "Odstrániť projekt",
    modal_delete_sheet_title: "Odstrániť hárok",
    placeholder_sprite_name: "Meno",
    placeholder_project_name: "Meno",
    placeholder_sheet_name: "Meno",
    placeholder_new_name: "Nové meno",
    action_create: "Vytvorte",
    action_add: "Pridať",
    action_rename: "Premenovať",
    action_duplicate: "Duplicitné",
    action_delete: "Odstrániť",
    action_cancel: "Zrušiť",
    confirm_delete_sprite: "Naozaj chcete odstrániť tohto sprite?",
    confirm_delete_project: "Naozaj chcete odstrániť tento projekt? Všetci škriatkovia budú odstránení.",
    confirm_delete_sheet: "Naozaj chcete odstrániť tento hárok?",
    err_select_sprite: "Najprv vyberte sprite.",
    err_select_project: "Najprv vyberte projekt.",
    err_name_empty: "Názov nemôže byť prázdny.",
    err_sprite_exists: "Sprite s týmto menom už existuje.",
    err_project_exists: "Projekt s týmto názvom už existuje.",
    err_no_content: "Žiadny obsah na uloženie.",
    err_no_changes: "Žiadne zmeny na uloženie.",
    err_delete_last_sheet: "Nie je možné odstrániť posledný hárok.",
    err_extract_frames: "Nepodarilo sa extrahovať žiadne snímky.",
    err_indexeddb: "Lokálne uloženie zlyhalo. Váš prehliadač nemusí podporovať IndexedDB.",
    msg_upload_success: "Odovzdanie bolo úspešné: {0}",
    msg_upload_failed: "Nahrávanie zlyhalo: {0}",
    msg_save_success: "Uloženie bolo úspešné.",
    msg_saving: "Ukladá sa...",
    msg_multi_save_result: "Uložené aktíva: {0}. Počet zlyhaní: {1}.",
    menu_title: "Menu",
    menu_save: "Uložiť",
    menu_save_all: "Uložiť všetko",
    menu_support: "Kontaktujte podporu",
    label_local_storage: "Miestne úložisko",
    label_sign_in: "Prihlásiť sa",
    modal_export_title: "Exportovať Sprite",
    label_filename: "Názov súboru",
    label_format: "Formátovať",
    action_export_confirm: "Exportovať",
};

export default translations;
